import React, { memo } from 'react';

import { BirthdayRow } from './BirthdayRow';
import { BlockingStatusRow } from './BlockingStatusRow';
import { CreatedAtRow } from './CreatedAtRow';
import { FullNameRow } from './FullNameRow';
import { IdRow } from './IdRow';
import { SocialNetworksRow } from './SocialNetworksRow';
import { UserTypeRow } from './UserTypeRow';
import { TagsRow } from './TagsRow';

export const CustomerSummary = memo(() => (
  <>
    <IdRow />
    <FullNameRow />
    <UserTypeRow />
    <BirthdayRow />
    <SocialNetworksRow />
    <BlockingStatusRow />
    <CreatedAtRow />
    <TagsRow />
  </>
));
